module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.proposta.fep && _vm.proposta.fep.id) ? _c('vue-headful', {
    attrs: {
      "title": 'SGP - FEP ' + _vm.proposta.fep.ano + '/' + _vm.proposta.fep.numero
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content-header ng-scope"
  }, [(_vm.proposta.fep) ? _c('h1', [_vm._v("Ficha de Enquadramento de Projetos  -  FEP  Nº  " + _vm._s(_vm.proposta.fep.ano) + "/" + _vm._s(_vm.proposta.fep.numero) + "\n      "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "title": '<h5>Gera a FEP abaixo de forma resumida em Excel</h5>'
    }
  }, [_c('download-excel', {
    attrs: {
      "data": _vm.json_data,
      "meta": _vm.json_meta,
      "type": "xls",
      "fields": _vm.json_fields,
      "name": _vm.fepExcel
    }
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimirRelatorio($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Imprimir ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvaFep($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Salvar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "error",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closewindow($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Sair do relatório ")])], 1) : _vm._e(), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Validação',
        href: '/'
      }, {
        text: 'Propostas',
        href: '#'
      }, {
        text: 'FEP',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "relatorio_fep"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "fep_titulo"
  }, [_c('div', [_vm._v("Ficha de Enquadramento de projetos")]), _vm._v(" "), (_vm.proposta.fep.id) ? _c('div', [_vm._v("FEP - Nº "), _c('span', {
    staticClass: "ressaltar titulo"
  }, [_vm._v(" " + _vm._s(_vm.proposta.fep.ano) + "/" + _vm._s(_vm.proposta.fep.numero))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Título")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.nome))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Proponente")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.nomeEntidade))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.cnpj)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Ano da Fep")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('ano')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.fep.ano),
      expression: "proposta.fep.ano"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "number",
      "name": "ano"
    },
    domProps: {
      "value": (_vm.proposta.fep.ano)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta.fep, "ano", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('ano')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('ano')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Número da Fep")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('numero')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.fep.numero),
      expression: "proposta.fep.numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "number",
      "name": "numero"
    },
    domProps: {
      "value": (_vm.proposta.fep.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta.fep, "numero", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('numero')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('numero')))]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group box-body"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Projeto Superior")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.projetoSuperior))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Eixo de Atuação")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.troca('CAMPOS_DE_ATUACAO', _vm.proposta.ds_categ_campo_atuacao)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Programa")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.troca('PROGRAMA', _vm.proposta.ds_fep_programa)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Ação")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.troca('ACAO', _vm.proposta.ds_categ_acao)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Parceria Estratégica (Vínculo)")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.vinculoParcerias))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Tipo de Ação")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.troca('TIPO_ACAO', _vm.proposta.ds_fep_tipo_acao)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Abrangência")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.abrangencia))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Participantes Diretos")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.publicoAlvo))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Prospecção")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.troca('PROSPECCAO', _vm.proposta.ds_categ_prospeccao)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Se Seleção, Nº/Nome Processo")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.troca('EDITAL', _vm.proposta.ds_categ_edital)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Cadeia Produtiva")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.troca('CADEIAS_PRODUTIVAS', _vm.proposta.ds_categ_atividade)))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group box-body"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped orcamento"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Próprios FBB")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFBB)))]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.totalFBB / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Terceiros - Parcerias Estratégicas")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalParceiro)))]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.totalParceiro / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Contrapartida - Proponente")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida)))]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.totalContrapartida / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Contrapartida - Outros Parceiros")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("real")(0)))]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("percentage")(0 / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro)))]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("percentage")((_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro) / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro))))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group box-body"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_fep_observacao),
      expression: "proposta.ds_fep_observacao"
    }, {
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "name": "ds_fep_observacao"
    },
    domProps: {
      "value": (_vm.proposta.ds_fep_observacao)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_fep_observacao", $event.target.value)
      }, _vm.resizable]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_fep_observacao)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group box-body"
  }, [_vm._m(6), _vm._v(" "), _c('table', {
    staticClass: "bloco"
  }, [_c('tr', [_c('td', [_c('textarea', {
    staticClass: "form-control"
  }, [_vm._v("Enquadramento validado em " + _vm._s(_vm.hoje))])])]), _vm._v(" "), _vm._m(7)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "float"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('img', {
    staticClass: "logo_relatorio",
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Dados do Projeto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Enquadramento na Árvore de Projetos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Orçamento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Recursos")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("% Valor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Observações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Enquadramento Orçamentário")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('div', {
    staticClass: "assinatura"
  }, [_c('span', [_vm._v("Assessor Gerência de Análise e  Avaliação - Orçamento")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b1b98de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/relatorioFep.vue
// module id = 1999
// module chunks = 1